import { render, staticRenderFns } from "./UIDatePicker.vue?vue&type=template&id=4f6b2bcc&scoped=true&"
import script from "./UIDatePicker.vue?vue&type=script&lang=js&"
export * from "./UIDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6b2bcc",
  null
  
)

export default component.exports